import React, { Component } from 'react';
import { Modal, Form, Radio, Input, Row, Col, message } from 'antd';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';

const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;

class ApprovalForm extends Component {
    render() {
        const { form } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const formItemLayout = {
            labelCol: {
                span: 4,
            },
            wrapperCol: {
                span: 15,
            },
        };

        return (<Form>
            <FormItem label="审核结论" {...formItemLayout}>
                {
                    getFieldDecorator('approvalStatus', {
                        rules: [{ required: true, message: '请选择审核结论' }],
                    })(<RadioGroup>
                        <Radio value="AGREE">审核通过</Radio>
                        <Radio value="REJECT">审核不通过</Radio>
                    </RadioGroup>)
                }
            </FormItem>
            {(getFieldValue('approvalStatus') == 'REJECT') && <Row>
                <Col span={14} offset={4}>
                    <FormItem>
                        {
                            getFieldDecorator('rejectRemark')(<TextArea
                                rows={3}
                                placeholder="请输入"
                                style={{ resize: 'none' }}
                            />)
                        }
                    </FormItem>
                </Col>
            </Row>}
        </Form>);
    }
}

class ApprovalModal extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = record => {
        this.setState({
            data: { ...record },
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            data: {},
            visible: false,
        });
    }

    handleSubmit = () => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }
            const { data } = this.state;
            const { coTraceId } = data || {};
            this.setState({ confirmLoading: true });
            Fetch.post(API_URL.investigation.approvalCoTrace, {
                coTraceId,
                ...values,
            }).then(res => {
                this.hide();
                const { success } = res;
                message.success(success);
                this.setState({ confirmLoading: false }, () => {
                    this.props.loadData();
                });
            }).catch(err => {
                this.setState({ loading: false });
            });
        });
    }

    render() {
        const { visible, confirmLoading, data } = this.state;
        const ApprovalForms = Form.create()(ApprovalForm);
        const { coTraceNum, coAmountAgreement, coCurrentMonthPercentStr, coBackPmFinishPercentStr } = data || {};
        return (
            <Modal
                title="CO审批"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
                confirmLoading={confirmLoading}
                onOk={this.handleSubmit}
            >
                <div className="cont-cont contract-record" style={{ margin: '0px 20px 20px' }}>
                    <div style={{ color: '#999', lineHeight: '24px' }}>CO跟踪单号：{coTraceNum}</div>
                    <div style={{ paddingLeft: 12, lineHeight: '24px', color: 'rgba(0, 0, 0, 0.85)' }}>
                        <div>CO金额是否已达成一致：{coAmountAgreement == 1 ? '是' : '否'}</div>
                        <div>CO回来当月的原累计完工%：{coCurrentMonthPercentStr}</div>
                        <div>CO回来入账后PM对项目完工百分比预估%：{coBackPmFinishPercentStr}</div>
                    </div>
                    <div style={{ borderTop: '1px solid #000', margin: '13px 0 5px' }} />
                    <ApprovalForms ref={el => this.formRef = el} />
                </div>
            </Modal>
        );
    }
}

export default ApprovalModal;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/ApprovalModal.js